import './agoUser.css'
import { useState, useEffect, useContext } from 'react'
import { useParams } from 'react-router-dom'
import DashboardLayout from 'components/layout/dashboard/DashboardLayout'
import AuthContext from 'contexte/AuthContext'
import { useTranslation } from 'react-i18next';
import PageLoader from 'components/pageLoader/PageLoader'
import { formatDate } from 'utils/date';
import { launchError, launchSuccess } from 'components/notifications'
import Notification from 'components/notifications/Notification'
import { fetchAgoUserById, uploadAgbkUserRiskLevel, uploadAgbkUtilityBill } from 'services/agoServices'
import AgoDataArray from './AgoDataArray/AgoDataArray'
import { formatPhoneNumber } from 'utils/numbers'

const AgoUser = () => {


  let { id } = useParams()
  const { t } = useTranslation();
  const { user } = useContext(AuthContext)


  const [loading, setLoading] = useState(true)
  const [userData, setUserData] = useState({})
  const [file, setFile] = useState(null);
  const [fileBase64, setFileBase64] = useState(null);
  const [fileType, setFileType] = useState('')
  const [riskLevel, setRiskLevel] = useState(userData?.risk_level);

  const fetchData = async () => {
    try {
      const getUserData = await fetchAgoUserById(user, id)
      setUserData(getUserData)
      setRiskLevel(getUserData.risk_level)
      setLoading(false)
    } catch {
      console.error('error')
    }
  }

  useEffect(() => {
    fetchData()
  }, [])


  function removeUndefinedPrefix(str) {
    return str.replace(/^undefined\//, '');
  }

  const handleFileChange = (event) => {
    if (event.target.files) {
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = function () {
        setFileBase64(reader.result)
      };
      reader.onerror = function (error) {
        console.error('Error: ', error);
      };
      setFile(event.target.files[0]);
    }
  };

  const uploadDocument = async () => {
    try {
      if (fileBase64) {
        const path = await uploadAgbkUtilityBill(user, id, fileBase64);
        setUserData(prev => {
          const newUserData = { ...prev };
          const key = 'utility_bill_pictures'
          const documents = [...newUserData[key]] || [];
          documents.push(path);
          newUserData[key] = documents
          return newUserData
        })
        setFileType('');
        setFileBase64(null);
        setFile(null)
        launchSuccess(t('notifications.users.userById.upload.success'))
      }
    } catch (error) {

      launchError(t('notifications.users.userById.upload.error'))
    }
  }


  const updateRiskLevel = async () => {
    try {
      const new_risk = await uploadAgbkUserRiskLevel(user, id, riskLevel);
      setUserData(prev => ({ ...prev, risk_level: new_risk }))
      launchSuccess(t('notifications.users.userById.risk_level.success'))
    } catch (error) {
      console.error(error)
      launchError(t('notifications.users.userById.risk_level.error'))
    }
  }


  return (
    <DashboardLayout page={t("pages_name.users") + ' / ' + id}>
      <div className=''>
        <Notification />
        {
          !loading ? (
            <div className='userById_container'>
              <div className='userData_header'>
                <div className='userData_profil'>
                  <img src={`${process.env.REACT_APP_CDN_URL}/usr/pic/${userData.pic}`}
                    alt="profilepic"
                    className='user_profile_pic' />
                  <div>
                    <p className='user_profil_name'>{userData.firstName} {userData.lastName}
                      {userData.isCertified &&
                        <span>
                          <img src="/img/certified.svg" alt="certified" />
                        </span>
                      }
                      {userData.is_deleted && ' (Compte supprimé)'}
                    </p>
                    <p className='user_profil_email'>{userData.email}</p>
                  </div>
                </div>
                <div>
                </div>
              </div>

              <div className='agbk_userData_multi_box'>
                <div className='agbk_userData_kyc'>
                  <p className='user_doc_title'>KYC :</p>
                  <div className='userData_kyc_box'>
                    <div className='userData_registerinfo userData_box'>
                      <p className='userData_registerinfo_created userData_p userData_item_desc'><span className='userData_item_title'>Inscription :</span> {formatDate({ date: userData.created_at, time: true })}</p>
                      {
                        userData.sumsub_status === "VERIFIED" && (
                          <p className='userData_registerinfo_approved userData_p userData_item_desc'><span className='userData_item_title'>Vérifié :</span> {formatDate({ date: userData.review_date, time: true })}</p>
                        )
                      }
                      <p className='userData_registerinfo_created userData_p userData_item_desc'><span className='userData_item_title'>Niveau de risque :</span>
                        <span className='update_risk_level_box'>
                          <select className='custom-select' value={riskLevel} onChange={(e) => setRiskLevel(e.target.value)}>
                            <option value='low'>Low</option>
                            <option value='medium'>Medium</option>
                            <option value='high'>High</option>
                          </select>
                          <button onClick={updateRiskLevel} className='history_export_button' disabled={riskLevel === userData.risk_level}>Modifier</button>
                        </span>
                      </p>
                    </div>
                    <div className='userData_statusinfo userData_box'>
                      <p className='userData_statusinfo_approved userData_p userData_item_desc'><span className='userData_item_title'>Sumsub :</span>{userData.sumsub_status}</p>
                    </div>
                  </div>
                </div>
                <div className='agbk_userData_chiffres_user'>
                  <p className='user_doc_title'>User :</p>
                  <div className='userData_wallet_box'>
                    <div className='userData_box'>
                      <p className='userData_p userData_item_desc'><span className='userData_item_title'>Numero de téléphone :</span>{formatPhoneNumber(userData.phone)}</p>
                      <p className="userData_p userData_item_desc"><span className='userData_item_title'>Date de naissance :</span> {formatDate({ date: userData.birthDate })}</p>
                      <p className="userData_p userData_item_desc userData_adresse"><span className='userData_item_title'>Adresse :</span>{userData.address}</p>
                    </div>
                    <div className='userData_box'>
                      <p className='userData_p userData_item_desc'><span className='userData_item_title'>Revenus :</span>{userData.income_amount}</p>
                      <p className='userData_p userData_item_desc'><span className='userData_item_title'>Source :</span>{userData.funding_source}</p>
                      <p className='userData_p userData_item_desc'><span className='userData_item_title'>Industrie :</span>{userData.industry}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className='userData_image'>
                <p className='user_doc_title'>Documents :</p>
                <div className='user_document_upload'>
                  <label htmlFor='upload_doc' className='history_export_button'>Choisir un fichier</label>
                  <input id='upload_doc' type='file' className='user_file_upload' onChange={handleFileChange} />
                  {file &&
                    <>
                      <label>{file.name}</label>
                      <button onClick={uploadDocument} className='history_export_button' disabled={!file}>Envoyer le document</button>
                    </>
                  }
                </div>

                <div className='user_documents_types_container'>
                  {userData?.idDocs?.length +
                    userData?.passport_pictures?.length +
                    userData?.utility_bill_pictures?.length === 0 &&
                    <p>Aucun document</p>
                  }
                  <div>
                    {userData?.idDocs?.length > 0 && <p className='user_document_sumsub_type'>Documents Sumsub</p>}
                    <div className='userData_documents_container'>
                      {
                        userData?.idDocs?.map((item, index) =>
                        (
                          <div className='userData_documents' key={index}>
                            <img src={`data:image/png;base64,%20${item}`} alt="profil img" className='userData_doc_item' />
                          </div>
                        )
                        )
                      }
                    </div>
                  </div>
                  {['passport_pictures', 'utility_bill_pictures'].map((docType, indexType) =>
                    <div key={indexType}>
                      {userData?.[docType]?.length > 0 && <p className='user_document_type'>{docType === 'passport_pictures' ? 'Passeport' : 'Justificatif de domicile'}</p>}
                      <div className='userData_documents_container'>

                        {
                          userData?.[docType]?.map((item, index) =>
                          (
                            <div className='userData_documents' key={index}>
                              <a href={item} target='_blank'>Document {index}</a>
                            </div>
                          )
                          )
                        }
                      </div>
                    </div>
                  )}
                </div>
              </div>



              <AgoDataArray id={id} />
            </div>
          ) : (
            <div className='pageLoaderBox'>
              <PageLoader />
            </div>
          )
        }
      </div>
    </DashboardLayout>
  )
}

export default AgoUser